module.exports = __webpack_public_path__ + "img/wisdom_icon1.99903183.png";